import * as React from "react";
import type { SVGProps } from "react";
const SvgIcFullfilment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.999 21V10.425a2.3 2.3 0 0 0-.912-1.8l-6.233-4.977a3.01 3.01 0 0 0-3.736 0L3.912 8.63A2.3 2.3 0 0 0 3 10.436v10.564"
    />
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M16.364 15.11v3.611c0 .466-.25.897-.653 1.13l-3.126 1.806a1.3 1.3 0 0 1-1.306 0l-3.126-1.805a1.31 1.31 0 0 1-.653-1.13V15.11c0-.466.25-.898.653-1.13l3.126-1.806a1.3 1.3 0 0 1 1.306 0l3.126 1.806c.404.232.653.664.653 1.13"
    />
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.684 14.444 11.93 16.9l4.246-2.457M11.932 21.839v-4.942"
    />
  </svg>
);
export default SvgIcFullfilment;
